import { useNavigate } from 'react-router-dom';

export default function SeoContent() {
  const navigate = useNavigate();

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Text Content */}
          <div className="flex-1 max-w-xl">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6 leading-tight">
              Что такое YOYBUY Spreadsheet?
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-5">
              <strong>YOYBUY Spreadsheet</strong> — это инновационная система заказов, которая позволяет
              пользователям покупать товары из Китая через структурированную таблицу. В отличие от
              традиционных агентов, <strong>YOYBUY spreadsheet</strong> отображает всю ключевую
              информацию в одном месте: цену товара, комиссию агента, стоимость доставки и итоговую цену.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-5">
              Платформа <strong>Kaspreadsheet</strong> делает процесс покупок из Китая максимально
              прозрачным. Вы видите все расходы заранее и можете сравнить различные варианты доставки.
              Система <strong>YOYBUY spreadsheet</strong> экономит до 40% по сравнению с обычными
              посредниками благодаря прямому доступу к поставщикам на Taobao и 1688.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Каждая категория товаров в <strong>YOYBUY spreadsheet</strong> — от обуви до парфюмерии —
              имеет свою страницу с актуальными ценами и наличием. Просто выберите нужную категорию
              и начните экономить уже сегодня.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => navigate('/blog/yoybuy-spreadsheet-guide')}
                className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Читать полный гид по YOYBUY Spreadsheet
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </button>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 rounded-full border-2 border-primary-500 text-primary-600 text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Перейти к платформе
                <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {/* Right: Image Card */}
          <div className="flex-1 w-full max-w-lg">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20flat%20lay%20of%20fashion%20items%20including%20sneakers%20hoodie%20and%20accessories%20on%20a%20warm%20cream%20surface%20with%20soft%20natural%20lighting%2C%20clean%20composition%20with%20plenty%20of%20negative%20space%2C%20Scandinavian%20aesthetic%2C%20warm%20neutral%20color%20palette%20of%20beige%20cream%20and%20olive%20tones%2C%20editorial%20product%20photography%2C%20high%20detail%2C%20organic%20textures&width=800&height=1000&seq=seo-content-img-01&orientation=portrait"
                alt="YOYBUY Spreadsheet товары"
                title="YOYBUY Spreadsheet категории товаров"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                <p className="text-white text-sm font-medium">YOYBUY Spreadsheet</p>
                <p className="text-white/80 text-xs">Более 14 категорий товаров из Китая</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}